import { useApiClient } from "@/hooks/useApiClient";

// バナーの表示位置。BE(FloatingBanner.Position)と揃える。
export type BannerPosition =
  | "floating"
  | "mypage_top"
  | "mypage_mid"
  | "login_modal";

// 状態アクション（閲覧履歴）。表示/非表示の状態管理に使う。
export type BannerAction = "clicked" | "hidden" | "dismissed";

// 計測イベント（CTR算出用）。状態管理とは別に1イベント1行で記録する。非表示系は view-history で記録する。
export type BannerEventType = "impression" | "click";

/**
 * バナーの状態アクション(view-history)と計測イベント(event)をPOSTするフック。
 * 一覧取得(SWR)は含まないため、表示側コンポーネントから軽量に呼べる。
 */
export const useBannerActions = (): {
  recordAction: (id: number, action: BannerAction) => Promise<void>;
  recordEvent: (
    id: number,
    eventType: BannerEventType,
    impressionId: string,
    position: BannerPosition
  ) => Promise<void>;
} => {
  const { apiClient } = useApiClient();

  const recordAction = async (
    id: number,
    action: BannerAction
  ): Promise<void> => {
    await apiClient.post(`/floating-banner/${id}/view-history`, { action });
  };

  const recordEvent = async (
    id: number,
    eventType: BannerEventType,
    impressionId: string,
    position: BannerPosition
  ): Promise<void> => {
    // リクエストボディのキーはcamelCaseで書く。apiClient(axios-case-converter)が
    // wireでsnake_case(event_type/impression_id)へ自動変換する（コードベース規約）。
    await apiClient.post(`/floating-banner/${id}/event`, {
      eventType,
      impressionId,
      position,
    });
  };

  return { recordAction, recordEvent };
};
